import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class AgreeFollowPolicies extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'You Agree to Follow All DHC and Operator Policies at All Times?',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: false,
    modalTitle: null,
    additionalFormComponent: null,
    requiredToContinue: true,
    errorRequiredMessage: 'To Proceed You Must Confirm!',
  };
}
